import React from "react";

const LockIcon = ({
  size = 20,
  color = "#626262",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15 8C16.0938 8 17 8.90625 17 10V16C17 17.125 16.0938 18 15 18H5C3.875 18 3 17.125 3 16V10C3 8.90625 3.875 8 5 8H6V6C6 3.8125 7.78125 2 10 2C11.7188 2 13.25 3.125 13.7813 4.78125C13.9063 5.1875 13.6875 5.59375 13.3125 5.71875C12.9062 5.84375 12.5 5.625 12.375 5.25C12.0312 4.21875 11.0625 3.5 10 3.5C8.59375 3.5 7.5 4.625 7.5 6V8H15ZM15.5 16V10C15.5 9.75 15.25 9.5 15 9.5H5C4.71875 9.5 4.5 9.75 4.5 10V16C4.5 16.2813 4.71875 16.5 5 16.5H15C15.25 16.5 15.5 16.2813 15.5 16Z"
        fill={color}
      />
    </svg>
  );
};

export default LockIcon;